var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1349,
    height: 362,
    viewBox: "0 0 1349 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 1349,
    height: 350,
    fill: "#286385"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92273 6.96179L-0.0390625 1L-6.00086 6.96179L-0.0390625 12.9236L5.92273 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8466 6.96179L74.8848 1L68.923 6.96179L74.8848 12.9236L80.8466 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 6.96179L149.809 1L143.847 6.96179L149.809 12.9236L155.77 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.694 6.96179L224.732 1L218.771 6.96179L224.732 12.9236L230.694 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.618 6.96179L299.656 1L293.694 6.96179L299.656 12.9236L305.618 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.542 6.96179L374.58 1L368.618 6.96179L374.58 12.9236L380.542 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.466 6.96179L449.504 1L443.542 6.96179L449.504 12.9236L455.466 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.39 6.96179L524.428 1L518.466 6.96179L524.428 12.9236L530.39 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.313 6.96179L599.352 1L593.39 6.96179L599.352 12.9236L605.313 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.237 6.96179L674.275 1L668.314 6.96179L674.275 12.9236L680.237 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.161 6.96179L749.199 1L743.237 6.96179L749.199 12.9236L755.161 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.085 6.96179L824.123 1L818.161 6.96179L824.123 12.9236L830.085 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.009 6.96179L899.047 1L893.085 6.96179L899.047 12.9236L905.009 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.932 6.96179L973.971 1L968.009 6.96179L973.971 12.9236L979.932 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.86 6.96179L1048.89 1L1042.93 6.96179L1048.89 12.9236L1054.86 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.78 6.96179L1123.82 1L1117.86 6.96179L1123.82 12.9236L1129.78 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.7 6.96179L1198.74 1L1192.78 6.96179L1198.74 12.9236L1204.7 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.63 6.96179L1273.67 1L1267.7 6.96179L1273.67 12.9236L1279.63 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.55 6.96179L1348.59 1L1342.63 6.96179L1348.59 12.9236L1354.55 6.96179Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92273 93.8856L-0.0390625 87.9238L-6.00086 93.8856L-0.0390625 99.8474L5.92273 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8466 93.8856L74.8848 87.9238L68.923 93.8856L74.8848 99.8474L80.8466 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 93.8856L149.809 87.9238L143.847 93.8856L149.809 99.8474L155.77 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.694 93.8856L224.732 87.9238L218.771 93.8856L224.732 99.8474L230.694 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.618 93.8856L299.656 87.9238L293.694 93.8856L299.656 99.8474L305.618 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.542 93.8856L374.58 87.9238L368.618 93.8856L374.58 99.8474L380.542 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.466 93.8856L449.504 87.9238L443.542 93.8856L449.504 99.8474L455.466 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.39 93.8856L524.428 87.9238L518.466 93.8856L524.428 99.8474L530.39 93.8856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.313 93.8856L599.352 87.9238L593.39 93.8856L599.352 99.8474L605.313 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.237 93.8856L674.275 87.9238L668.314 93.8856L674.275 99.8474L680.237 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.161 93.8856L749.199 87.9238L743.237 93.8856L749.199 99.8474L755.161 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.085 93.8856L824.123 87.9238L818.161 93.8856L824.123 99.8474L830.085 93.8856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.009 93.8856L899.047 87.9238L893.085 93.8856L899.047 99.8474L905.009 93.8856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.932 93.8856L973.971 87.9238L968.009 93.8856L973.971 99.8474L979.932 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.86 93.8861L1048.89 87.9243L1042.93 93.8861L1048.89 99.8479L1054.86 93.8861Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.78 93.8861L1123.82 87.9243L1117.86 93.8861L1123.82 99.8479L1129.78 93.8861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.7 93.8856L1198.74 87.9238L1192.78 93.8856L1198.74 99.8474L1204.7 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.63 93.8856L1273.67 87.9238L1267.7 93.8856L1273.67 99.8474L1279.63 93.8856Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.55 93.8861L1348.59 87.9243L1342.63 93.8861L1348.59 99.8479L1354.55 93.8861Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92273 180.81L-0.0390625 174.848L-6.00086 180.81L-0.0390625 186.772L5.92273 180.81Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8466 180.809L74.8848 174.848L68.923 180.809L74.8848 186.771L80.8466 180.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 180.809L149.809 174.848L143.847 180.809L149.809 186.771L155.77 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.694 180.809L224.732 174.848L218.771 180.809L224.732 186.771L230.694 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.618 180.809L299.656 174.848L293.694 180.809L299.656 186.771L305.618 180.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.542 180.809L374.58 174.848L368.618 180.809L374.58 186.771L380.542 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.466 180.809L449.504 174.848L443.542 180.809L449.504 186.771L455.466 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.39 180.809L524.428 174.848L518.466 180.809L524.428 186.771L530.39 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.313 180.809L599.352 174.848L593.39 180.809L599.352 186.771L605.313 180.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.237 180.809L674.275 174.848L668.314 180.809L674.275 186.771L680.237 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.161 180.809L749.199 174.848L743.237 180.809L749.199 186.771L755.161 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.085 180.809L824.123 174.848L818.161 180.809L824.123 186.771L830.085 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.009 180.809L899.047 174.848L893.085 180.809L899.047 186.771L905.009 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.932 180.809L973.971 174.848L968.009 180.809L973.971 186.771L979.932 180.809Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.86 180.809L1048.89 174.848L1042.93 180.809L1048.89 186.771L1054.86 180.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.78 180.81L1123.82 174.848L1117.86 180.81L1123.82 186.772L1129.78 180.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.7 180.81L1198.74 174.848L1192.78 180.81L1198.74 186.772L1204.7 180.81Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.63 180.81L1273.67 174.848L1267.7 180.81L1273.67 186.772L1279.63 180.81Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.55 180.81L1348.59 174.848L1342.63 180.81L1348.59 186.772L1354.55 180.81Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92273 267.733L-0.0390625 261.771L-6.00086 267.733L-0.0390625 273.695L5.92273 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8466 267.733L74.8848 261.771L68.923 267.733L74.8848 273.695L80.8466 267.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 267.733L149.809 261.771L143.847 267.733L149.809 273.695L155.77 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.694 267.733L224.732 261.771L218.771 267.733L224.732 273.695L230.694 267.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.618 267.733L299.656 261.771L293.694 267.733L299.656 273.695L305.618 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.542 267.733L374.58 261.771L368.618 267.733L374.58 273.695L380.542 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.466 267.733L449.504 261.771L443.542 267.733L449.504 273.695L455.466 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.39 267.733L524.428 261.771L518.466 267.733L524.428 273.695L530.39 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.313 267.733L599.352 261.771L593.39 267.733L599.352 273.695L605.313 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.237 267.733L674.275 261.771L668.314 267.733L674.275 273.695L680.237 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.161 267.733L749.199 261.771L743.237 267.733L749.199 273.695L755.161 267.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.085 267.733L824.123 261.771L818.161 267.733L824.123 273.695L830.085 267.733Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.009 267.734L899.047 261.772L893.085 267.734L899.047 273.696L905.009 267.734Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.932 267.734L973.971 261.772L968.009 267.734L973.971 273.696L979.932 267.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.86 267.734L1048.89 261.772L1042.93 267.734L1048.89 273.696L1054.86 267.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.78 267.734L1123.82 261.772L1117.86 267.734L1123.82 273.696L1129.78 267.734Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.7 267.734L1198.74 261.772L1192.78 267.734L1198.74 273.696L1204.7 267.734Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.63 267.734L1273.67 261.772L1267.7 267.734L1273.67 273.696L1279.63 267.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.55 267.734L1348.59 261.772L1342.63 267.734L1348.59 273.696L1354.55 267.734Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92273 354.657L-0.0390625 348.695L-6.00086 354.657L-0.0390625 360.619L5.92273 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8466 354.657L74.8848 348.695L68.923 354.657L74.8848 360.619L80.8466 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 354.657L149.809 348.695L143.847 354.657L149.809 360.619L155.77 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.694 354.657L224.732 348.695L218.771 354.657L224.732 360.619L230.694 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.618 354.657L299.656 348.695L293.694 354.657L299.656 360.619L305.618 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.542 354.657L374.58 348.695L368.618 354.657L374.58 360.619L380.542 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.466 354.657L449.504 348.695L443.542 354.657L449.504 360.619L455.466 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.39 354.657L524.428 348.695L518.466 354.657L524.428 360.619L530.39 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.313 354.657L599.352 348.695L593.39 354.657L599.352 360.619L605.313 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.237 354.657L674.275 348.695L668.314 354.657L674.275 360.619L680.237 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.161 354.657L749.199 348.695L743.237 354.657L749.199 360.619L755.161 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.085 354.657L824.123 348.695L818.161 354.657L824.123 360.619L830.085 354.657Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.009 354.658L899.047 348.696L893.085 354.658L899.047 360.619L905.009 354.658Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.932 354.658L973.971 348.696L968.009 354.658L973.971 360.619L979.932 354.658Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.86 354.658L1048.89 348.696L1042.93 354.658L1048.89 360.619L1054.86 354.658Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.78 354.658L1123.82 348.696L1117.86 354.658L1123.82 360.619L1129.78 354.658Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.7 354.658L1198.74 348.696L1192.78 354.658L1198.74 360.619L1204.7 354.658Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.63 354.658L1273.67 348.696L1267.7 354.658L1273.67 360.619L1279.63 354.658Z",
    stroke: "white",
    strokeWidth: 0.630746
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.55 354.658L1348.59 348.696L1342.63 354.658L1348.59 360.619L1354.55 354.658Z",
    stroke: "white",
    strokeWidth: 0.630746
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundAbout);
export default __webpack_public_path__ + "static/media/background_about.7709b318c90e43e9cfb2ede68e97405c.svg";
export { ForwardRef as ReactComponent };